import React from "react";
import { withStyles } from '@material-ui/styles';

import Masonry from 'react-masonry-css';

import NavigationTabContent from "../../../components/navigation_tab_content.js";

import pageStyles from "../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../base_info_page.js.jsx";

import InvestmentStatisticsCard from "./cards/investment_statistics_card.js";
import PersonalInfoCard from "./cards/personal_info_card.js";
import NotesCard from "./cards/notes_card.js";
import BirthCard from "./cards/birth_card.js";
import ContactsCard from "./cards/contacts_card.js";
import AddressCard from "./cards/address_card.js"
import IdentityDataCard from "./cards/identity_data_card.js";
import RegistrationInfoCard from "./cards/registration_info_card.js";
import PaymentMethodsCard from "./cards/payment_methods_card.js";
import QuestionnaireCard from "./cards/questionnaire_card.js";

const styles = theme => ({
  masonryGrid: {
    display: "flex",
    marginLeft: "-15px",
    width: "auto"
  },
  masonryColumn: {
    paddingLeft: "15px",
    backgroundClip: "padding-box",
    "& > div": {
      marginBottom: "15px",
    }
  }
});


const UserInfoTab = (props) => {

  const { user, errorData, classes } = props;
  const { onItemChanged } = props;

  if ( errorData && errorData.fields && errorData.fields.email != null) {
    if (!errorData.personalInfo)
      errorData.personalInfo = { fields: {}}
    if (!errorData.personalInfo.fields)
    errorData.personalInfo.fields = {}
    errorData.personalInfo.fields.email = errorData.fields.email
  }

  return (
    <NavigationTabContent visible = { props.visible } >
      <Masonry className = { classes.masonryGrid }
               columnClassName = { classes.masonryColumn }
               breakpointCols = { 1 } >
        <div className = { classes.item } >
          <InvestmentStatisticsCard user = { user } />
        </div>
      </Masonry>
      <Masonry className = { classes.masonryGrid }
               columnClassName = { classes.masonryColumn }
               breakpointCols = { 2 } >
        <div className = { classes.item } >
          <PersonalInfoCard errorData = { errorData }
                            onItemChanged = { onItemChanged }
                            user = { user } />
        </div>
        <div className = { classes.item } >
          <NotesCard errorData = { errorData }
                     onItemChanged = { onItemChanged }
                     user = { user } />
        </div>
        <div className = { classes.item } >
          <BirthCard errorData = { errorData }
                     onItemChanged = { onItemChanged }
                     user = { user } />
        </div>
        <div className = { classes.item } >
          <ContactsCard errorData = { errorData }
                        onItemChanged = { onItemChanged }
                        user = { user } />
        </div>
        <div className = { classes.item } >
          <AddressCard errorData = { errorData }
                       onItemChanged = { onItemChanged }
                       user = { user } />
        </div>
        <div className = { classes.item } >
          <IdentityDataCard errorData = { errorData }
                            onItemChanged = { onItemChanged }
                            user = { user } />
        </div>
        <div className = { classes.item } >
          <PaymentMethodsCard errorData = { errorData }
                              onItemChanged = { onItemChanged }
                              user = { user } />
        </div>
        <div className = { classes.item } >
          <QuestionnaireCard user = { user } />
        </div>
        <div className = { classes.item } >
          <RegistrationInfoCard user = { user } />
        </div>
      </Masonry>
    </NavigationTabContent>
  );
}

UserInfoTab.defaultProps = {
}

export default withStyles(
  (theme) => ({
    ...pageStyles(theme),
    ...infoPageStyles(theme),
    ...styles(theme),
  }),
  { withTheme: true }
)(UserInfoTab);
